jQuery(function ($) {
  // Header
  var beforePos = 0; //スクロールの値の比較用の設定

  //スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
  function ScrollAnime() {
    var elemTop = $('.contents').offset().top; //.construct-mainの位置まできたら
    var scroll = $(window).scrollTop();
    //ヘッダーの出し入れをする
    if (scroll == beforePos) {
      //IE11対策で処理を入れない
    } else if (elemTop > scroll || 0 > scroll - beforePos) {
      //ヘッダーが上から出現する
      $('.header').removeClass('upMove'); //#headerにUpMoveというクラス名を除き
      $('.header').addClass('downMove'); //#headerにDownMoveのクラス名を追加
    } else {
      //ヘッダーが上に消える
      $('.header').removeClass('downMove'); //#headerにDownMoveというクラス名を除き
      $('.header').addClass('upMove'); //#headerにUpMoveのクラス名を追加
    }

    beforePos = scroll; //現在のスクロール値を比較用のbeforePosに格納
  }

  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    ScrollAnime(); //スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
  });

  // ページが読み込まれたらすぐに動かしたい場合の記述
  $(window).on('load', function () {
    ScrollAnime(); //スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
  });

  // Burger
  $('#jsBurger').on('click', function () {
    $('body').toggleClass('visible-mobile-menu');
  });

  const pageTop = $('#pagetop');
  pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }
  });
  pageTop.click(function () {
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });

  // タブ
  $('.tab').on('click', function () {
    const index = $('.tab').index(this);
    $(this).addClass('active').siblings('.tab').removeClass('active');
    $(this).closest('.tab-wrapper').next('.panel-wrapper').find('.panel').removeClass('show');
    $('.panel').eq(index).addClass('show');
  });

  // アコーディオン開閉ボタンのDOMを変数に格納。
  $('.accordion__head').on('click', function () {
    $(this).parent().toggleClass('active');
  });
});
